import { callExternalApi, CallResult } from '../callExternalApi';
import { ScorerAnswers, ScorerConfirmation, ScorerDraftSaved, ScorerView } from '../../types/advise';

const SCORER_URL = 'api/advise/scorer';

// The link's secret is the scorer's only credential, so neither the Portal's bearer nor its cookies are sent, even
// from a browser signed in to the Portal.
const SKIP_PORTAL_AUTH = true;

const scorerRequest = (token: string) => ({
  headers: { 'content-type': 'application/json', 'X-Scorer-Token': token },
  withCredentials: false
});

export const fetchScorerView = async (token: string): Promise<CallResult<ScorerView>> =>
  callExternalApi<ScorerView>({ url: SCORER_URL, method: 'GET', ...scorerRequest(token) }, SKIP_PORTAL_AUTH);

// A draft that arrives after submit changes nothing and answers the confirmation.
export const updateScorerDraft = async (
  token: string,
  answers: ScorerAnswers
): Promise<CallResult<ScorerDraftSaved | ScorerConfirmation>> =>
  callExternalApi<ScorerDraftSaved | ScorerConfirmation>(
    { url: `${SCORER_URL}/draft`, method: 'PUT', ...scorerRequest(token), data: answers },
    SKIP_PORTAL_AUTH
  );

export const postScorerSubmission = async (
  token: string,
  answers: ScorerAnswers
): Promise<CallResult<ScorerConfirmation>> =>
  callExternalApi<ScorerConfirmation>(
    { url: `${SCORER_URL}/submission`, method: 'POST', ...scorerRequest(token), data: answers },
    SKIP_PORTAL_AUTH
  );
